import axios from 'axios'
import {PasswordModel} from '../ProfileModels'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const UPDATE_PASSWORD = `${API_URL}/update-password`

export const service = {
  // Server should return AuthModel

  updatePassword: (body: PasswordModel) => {
    return axios.post(UPDATE_PASSWORD, body)
  },
}
